export type MatchType = 'EXACT' | 'PHRASE' | 'BROAD' | 'UNKNOWN';

export const MATCH_TYPE_COLORS: Record<string, string> = {
  EXACT: 'bg-purple-50 text-purple-600',
  PHRASE: 'bg-blue-50 text-blue-600',
  BROAD: 'bg-gray-100 text-gray-600',
  UNKNOWN: 'bg-gray-100 text-gray-600',
};

export function getMatchTypePillClass(matchType: string | null | undefined): string {
  const key = (matchType ?? 'UNKNOWN').toUpperCase();
  return MATCH_TYPE_COLORS[key] ?? MATCH_TYPE_COLORS.UNKNOWN;
}

export function formatMatchType(matchType: string | null | undefined): string {
  const key = (matchType ?? 'UNKNOWN').toUpperCase();
  return key === 'UNKNOWN' ? '—' : key;
}
